<nz-upload [nzShowUploadList]="true" nzListType="picture-card" nzType="drag" [(nzFileList)]="fileList" [nzMultiple]="true" nzAction="https://httpbin.org/post"
    (nzChange)="handleChange($event)">
    <p class="ant-upload-drag-icon">
        <nz-icon nzType="inbox" />
    </p>
    <p class="ant-upload-text">Click or drag file to this area to upload</p>
</nz-upload>

